import React from 'react'
import { shallow } from 'enzyme'
import SectionTable from '../SectionTable'

describe('SectionTable', () => {
  let wrapper, props, instance

  beforeAll( () => {
    props = {
      objectRows: [],
      sectionTitle: 'Title',
      loan: {
        rid: 22
      },
      customHeaders: null,
      section: 'PayrollInfo',
      helpers: {},
      canEdit: true,
      customerService: true
    }
    wrapper = shallow(<SectionTable {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    it('should return obj', () => {
      expect(wrapper).toBeTruthy()
    })
  })

  describe('#adminCanEditRow', () => {
    describe('when is editable', () => {
      describe('when there is a customer service role', () => {
        it('should return boolean', () => {
          const { adminCanEditRow } = instance
    
          expect(adminCanEditRow()).toBeTruthy()
        })
      })

      describe('when there is not customer service role', () => {
        it('should return boolean', () => {
          wrapper.setProps({ customerService: false })
          const { adminCanEditRow } = instance
    
          expect(adminCanEditRow()).toBeFalsy()
        })
      })
    })

    describe('when is not editable', () => {
      it('should return boolean', () => {
        wrapper.setProps({ canEdit: false })
        const { adminCanEditRow } = instance
  
        expect(adminCanEditRow()).toBeFalsy()
      })
    })
  })
})